export default __webpack_public_path__ + "static/media/icon-push-notification-round.1b655bfe.svg";